<section class="payment__summary" *ngIf="payment && !isMobile">
    <h2 *ngIf="!titleAsH1" class="payment__summary--title">
        {{ content.chooseMethod }}
    </h2>
    <h1 *ngIf="titleAsH1" class="payment__summary--title">
        {{ content.chooseMethod }}
    </h1>

    <div class="payment__summary--row-wrapper">
        <div class="payment__summary--row">
            <div class="payment__summary--left-column">
                <p>{{ content.type }}</p>
            </div>
            @if (feeChecker('administrativeFee')) {
            <div class="payment__summary--administrative-fee">
                {{ content.administrativeFee }}
            </div>
            }

            @if(feeChecker('taxFee')) {
            <div class="payment__summary--register-fee">
                {{ content.taxFee }}
            </div>
            }

            @if(feeChecker('postalFee')) {
            <div class="payment__summary--postal-fee">
                {{ content.postalFee }}
            </div>
            }
            <div class="payment__summary--right-column payment__summary--grid-last">
                <p>{{ content.price }}</p>
            </div>
        </div>
        <ng-container *ngFor="let item of payment.items">
            <div class="payment__summary--row">
                <div class="payment__summary--left-column">
                    <p>
                        <strong>{{ item.documentType }}</strong>
                    </p>
                </div>
                @if(item.administrativeFee !== null && item.administrativeFee !== undefined) {
                <div class="payment__summary--administrative-fee">
                    <p>
                        <strong>{{ item.administrativeFee / 100 }} {{ content.units }}</strong>
                    </p>
                </div>
                }

                @if(item.taxFee !== null && item.taxFee !== undefined) {
                <div class="payment__summary--register-fee">
                    <p>
                        <strong>{{ item.taxFee / 100 }} {{ content.units }}</strong>
                    </p>
                </div>
                }

                @if(item.postalFee !== null && item.postalFee !== undefined) {
                <div class="payment__summary--postal-fee">
                    <p>
                        <strong>{{ item.postalFee / 100 }} {{ content.units }}</strong>
                    </p>
                </div>
                }

                <div class="payment__summary--right-column payment__summary--grid-last">
                    @if(item.taxFee !== null && item.administrativeFee !== null && item.postalFee !== null) {
                    <p>
                        <strong>{{ (item.taxFee + item.administrativeFee + item.postalFee) / 100 }} {{ content.units
                            }}</strong>
                    </p>
                    } @else {
                    <p>
                        <strong>{{ payment.fees?.totalFee / 100 }} {{ content.units
                            }}</strong>
                    </p>
                    }
                </div>
            </div>
        </ng-container>
    </div>

    <div class="payment__summary--row payment__summary--sum">
        <div class="payment__summary--left-column">
            <p>
                <strong>{{ content.priceSum }}</strong>
            </p>
        </div>
        <div class="payment__summary--right-column payment__summary--grid-last">
            <p>
                <strong>{{ (payment.fees?.totalFee) / 100 }}
                    {{ content.units }}</strong>
            </p>
        </div>
    </div>
</section>

<section class="payment__summary--mobile" *ngIf="payment && isMobile">
    <h2 *ngIf="!titleAsH1" class="payment__summary--title">
        {{ content.chooseMethod }}
    </h2>
    <h1 *ngIf="titleAsH1" class="payment__summary--title">
        {{ content.chooseMethod }}
    </h1>

    <div class="payment__summary--mobile-row-wrapper">
        <div class="payment__summary--mobile-row m-0">
            <div class="payment__summary--mobile-left-column">
                <p>{{ content.type }}</p>
            </div>
            <div class="payment__summary--mobile-right-column">
                <p>{{ content.price }}</p>
            </div>
        </div>
        <ng-container *ngFor="let item of payment.items">
            <div class="payment__summary--mobile-row">
                <div class="payment__summary--mobile-left-column">
                    <div class="payment__summary--mobile-type">
                        <p>
                            <strong>{{ item.documentType }}</strong>
                        </p>
                    </div>
                    @if(feeChecker('administrativeFee')) {
                    <div class="payment__summary--mobile-administrative-fee">
                        <p>{{ content.administrativeFee }}</p>
                    </div>
                    }

                    @if(feeChecker('taxFee')) {
                    <div class="payment__summary--mobile-register-fee">
                        <p>{{ content.taxFee }}</p>
                    </div>
                    }

                    @if(feeChecker('postalFee')) {
                    <div class="payment__summary--mobile-postal-fee">
                        <p>{{ content.postalFee }}</p>
                    </div>
                    }
                </div>
                <div class="payment__summary--mobile-right-column">
                    <div class="payment__summary--mobile-price">
                        <p>
                            <strong>{{ (item.taxFee + item.administrativeFee + item.postalFee) / 100 }}
                                {{ content.units }}</strong>
                        </p>
                    </div>
                    @if(item.administrativeFee !== null && item.administrativeFee !== undefined) {
                    <div class="payment__summary--mobile-administrative-fee">
                        <p>
                            <strong>{{ item.administrativeFee / 100 }} {{ content.units }}</strong>
                        </p>
                    </div>
                    }

                    @if(item.taxFee !== null && item.taxFee !== undefined) {
                    <div class="payment__summary--mobile-register-fee">
                        <p>
                            <strong>{{ item.taxFee / 100 }} {{ content.units }}</strong>
                        </p>
                    </div>
                    }

                    @if(item.postalFee !== null && item.postalFee !== undefined) {
                    <div class="payment__summary--mobile-postal-fee">
                        <p>
                            <strong>{{ item.postalFee / 100 }} {{ content.units }}</strong>
                        </p>
                    </div>
                    }
                </div>
            </div>
        </ng-container>
        <div class="payment__summary--mobile-row payment__summary--mobile-sum m-0">
            <div class="payment__summary--mobile-left-column">
                <p>
                    <strong>{{ content.priceSum }}</strong>
                </p>
            </div>
            <div class="payment__summary--mobile-right-column">
                <p>
                    <strong>{{ (payment.fees?.totalFee) / 100 }}
                        {{ content.units }}</strong>
                </p>
            </div>
        </div>
    </div>
</section>